import React, { useEffect } from 'react'
import { useSelector } from "react-redux";
import { Link, useNavigate } from 'react-router-dom'

import CustomCard from '../../utils/components/CustomCard';
import { Box, Divider, Typography, Grid, Container, Breadcrumbs, Button } from '@mui/material';

function InformesIndex() {

    const auth = useSelector((state) => state.auth);
    let navigate = useNavigate();

    useEffect(() => {
        if (!['Admin'].includes(auth.user.rol)) {
            navigate('/dashboard');
        }
        document.title = 'Informes';
    }, [auth])

    return (

        <Container maxWidth='xl' style={{ marginTop: '10px' }}>
            <Box className='text-center' >
                <Typography variant='h4' style={{ fontWeight: 700 }}>Informes</Typography>
            </Box>
            <Button size='small' variant='outlined' onClick={() => navigate('/dashboard')}><i className='fad fa-arrow-left'></i> &nbsp;&nbsp;Regresar</Button>
            <Divider variant="middle" className='my-3' />
            <Grid container spacing={3}>
                {cards.map((card, i) => {
                    if (card.auth.includes(auth.user.rol)) {
                        return (
                            <Grid item key={i} xs={12} sm={6} md={4}>
                                <CustomCard
                                    title={card.title}
                                    to={card.to}
                                    button={card.button}
                                    cardIco={card.cardIco}
                                    text={card.text}
                                    color={'primary.main'}
                                    btnColor={'primary'}
                                />
                            </Grid>
                        )
                    }
                    return null;
                })}
            </Grid>
            <br></br>
        </Container>
    )
}

const cards = [
    {
        title: "Reporte de Ventas",
        text: "Genera un reporte de ventas en un rango de fechas.",
        button: "Reporte ventas",
        cardIco: "fad fa-chart-line fa-3x",
        to: "/informes/reporteVentas",
        auth: ['Admin', 'Secretaria', 'Ayudante']
    }
]

export default InformesIndex;